{
  "version": 1,
  "cardBacks": [
    { "id": "pomegranate", "nameKey": "cardBack.pomegranate", "label": "Pomegranate", "src": "/assets/cards/hokm/backs/pomegranate.jpg", "price": 0 },
    { "id": "flame", "nameKey": "cardBack.flame", "label": "Flame", "src": "/assets/cards/hokm/backs/flame.jpg", "price": 90 },
    { "id": "sun", "nameKey": "cardBack.sun", "label": "Sun", "src": "/assets/cards/hokm/backs/sun.jpg", "price": 120 },
    { "id": "heart", "nameKey": "cardBack.heart", "label": "Heart", "src": "/assets/cards/hokm/backs/heart.png", "price": 160 },
    { "id": "rose", "nameKey": "cardBack.rose", "label": "Rose", "src": "/assets/cards/hokm/backs/rose.png", "price": 220 }
  ],
  "cardFronts": [
    { "id": "classic", "nameKey": "cardFront.classic", "label": "Classic", "previewCardId": "spades-a", "price": 0 },
    { "id": "ivory", "nameKey": "cardFront.ivory", "label": "Ivory", "previewCardId": "hearts-a", "price": 80 },
    { "id": "midnight", "nameKey": "cardFront.midnight", "label": "Midnight", "previewCardId": "clubs-a", "price": 120 },
    { "id": "royal", "nameKey": "cardFront.royal", "label": "Royal", "previewCardId": "diamonds-a", "price": 180 }
  ]
}
